import { Component, OnInit } from '@angular/core';
import {RSDialogComponentModel} from "../../../libs/rsnotify/rsdialog.component.model";
import {ExtensionCategory, ExtensionEvent, Hort360PropertySummary} from "../../../../functions/src/types";
import {DataService} from "../../services/data.service";
import invert from "invert-color";
import {Router} from "@angular/router";

@Component({
  selector: 'app-view-event',
  templateUrl: './view-event.component.html',
  styleUrls: ['./view-event.component.scss']
})
export class ViewEventComponent extends RSDialogComponentModel implements OnInit {

  private eventCategory: ExtensionCategory;
  get category() {
    if (!this.eventCategory && this.event.category) {
      this.eventCategory = this.dataService.categories.getValue().find(c => c.id === this.event.category);
    }
    return this.eventCategory;
  }
  get event(): ExtensionEvent {
    return (this.dialogValues && this.dialogValues.event) || {} as ExtensionEvent;
  }
  get properties(): Hort360PropertySummary[] {
    return (this.dialogValues && this.dialogValues.properties) || [] as Hort360PropertySummary[];
  }
  get propertyAttendees(): {[key: number]: number } {
    return (this.dialogValues && this.dialogValues.propertyAttendees) || {};
  }

  constructor(private dataService: DataService, private router: Router) {
    super();
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  ngOnInit(): void { }

  selectAttendee(property: Hort360PropertySummary) {
    this.dialogHandles.close();
    this.router.navigate(['growers', property.id]);
  }

}
